export const userManagementBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL

export const dataServiceBaseUrl = process.env.REACT_APP_DATA_SERVICE_BASE_URL

export const webUIBaseUrl = process.env.REACT_APP_WEB_UI_BASE_URL

export const userManagement = {
  loginController: {
    login: "/login",
    logout: "/logout",
  },
  permissionController: {
    getAllPermissions: "/permissions/findAllPermissions",
  },
  roleController: {
    getRoles: "/roles",
    addRole: "/roles",
    findRoleById: "/roles/",
    updateRole: "/roles/",
    deleteRole: "/roles/",
  },
  userController: {
    addUser: "/users",
    findUserById: "/users",
    updateUser: "/users",
    deleteUser: "/users",
    getUsers: "/users",
    forgotPassword: "/users/forgotPassword",
    resetPassword: "/users/resetPassword",
    uploadUsers: "/users/upload",
    findUsername: "/users/username",
    findAllUsers: "/users/getAllUsers"
  },
  userRoleController: {
    getUserRoleById: "/roles",
    updateUserRole: "/roles/updateUserRole",
    deleteUserRoleById: "/roles/deleteUserRole",
    getAllUserRole: "/roles/findAllUserRole",
    saveUserRole: "/roles",
    findAllUserRole: "/roles/findAllUserRole",
  },
  userGroupController: {
    getUserGroupById: "/userGroup/findUserGroup",
    updateUserGroup: "/userGroup/updateUserGroup",
    deleteUserGroupById: "/userGroup/deleteUserGroup",
    getAllUserGroup: "/userGroup/findAllUserGroup",
    saveUserGroup: "/userGroup/saveUserGroup",
  },
  usersController: {
    getUserById: "/users",
    updateUser: "/users",
    deleteUserById: "/users",
    getAllUser: "/users",
    saveUser: "/users",
    resetPassword: "/users/resetPassword",
    getAllUsersWithSearch: "/users/getAllUsersWithSearch",
    getUserByGroupId: "users/group"
  },
  countryController: {
    getAllCountries: "/country/getAllCountries",
    saveCountry: "/country/saveCountry",
    updateCountry: "/country/updateCountry",
    deleteCountry: "/country/deleteCountry",
    getCountryById: "/country/getCountryById",
    getAllCountriesWithSearch: "/country/getAllCountriesWithSearch",
    getAllCountryWithPagination: "/country/getAllCountries",
  },
  cityController: {
    getAllCities: "/city/getAllCities",
  },
  stateController: {
    getState: "/state/getState",
    saveState: "/state/saveState",
    updateState: "/state/updateState",
    deleteState: "/state/deleteState",
    getStateById: "/state/getStateById",
    getAllStates: "/state/getAllStates",
    getAllStatesWithSearch: "/state/getAllStatesWithSearch",
  },
  auditLogController: {
    saveAuditLog: "auditLog/save",
    getAuditLog: "auditLog/find"
  },
  accountCategoryMasterController: {
    getAllAccountCategoryWithPagination: "/accountCategory",
    updateAccountCategory: "/accountCategory/update",
    deleteAccountCategoryById: "accountCategory/delete",
    getAccountCategoryById: "/accountCategory/getById",
    saveAccountCategory: "/accountCategory/save",
    getAllAccountCategoryWithSearch: "/accountCategory/search",
    getAllAccountCategory: '/accountCategory/getAll',
    bulkSaveAccountCategory: "/accountCategory/uploadBulk",
  },
  accountMasterController: {
    getAllAccountWithPagination: "/account",
    updateAccount: "/account/update",
    deleteAccountById: "account/delete",
    getAccountById: "/account/getById",
    saveAccount: "/account/save",
    getAllAccountWithSearch: "/account/search",
    getAllAccount: '/account/getAll',
    bulkSaveAccount: "/account/uploadBulk",
  },
  organizationMasterController: {
    getAllOrganizationMaster: "/organizationMaster",
    saveOrganizationMaster: "/organizationMaster/save",
    updateOrganizationMaster: "/organizationMaster/update",
    deleteOrganizationMaster: "/organizationMaster/delete",
    getOrganizationMasterById: "/organizationMaster/getById",
    getAllOrganizationMasterBySearch: "/organizationMaster/search",
    findAllOrganizationMaster: "/organizationMaster/getAll",
    bulkSaveOrganizationMaster: "/organizationMaster/uploadBulk",
  },
  memberMasterController: {
    getAllMemberMaster: "/member",
    saveMemberMaster: "/member/save",
    updateMemberMaster: "/member/update",
    deleteMemberMaster: "/member/delete",
    getMemberMasterById: "/member/getById",
    getAllMemberMasterBySearch: "/member/search",
    findAllMemberMasterMaster: "/member/getAll",
    bulkSaveMemberMasterMaster: "/member/uploadMemberMasterBulk",
  },
  memberCategoryMasterController: {
    getAllMemberCategoryMaster: "/memberCategory",
    saveMemberCategoryMaster: "/memberCategory/save",
    updateMemberCategoryMaster: "/memberCategory/update",
    deleteMemberCategoryMaster: "/memberCategory/delete",
    getMemberCategoryMasterById: "/memberCategory/getById",
    getAllMemberCategoryMasterBySearch: "/memberCategory/search",
    findAllMemberCategoryMasterMaster: "/memberCategory/getAll",
    bulkSaveMemberCategoryMasterMaster: "/memberCategory/uploadBulk",
  },

  openingBalanceFinanceController: {
    getAllOpeningBalanceFinance: "/opening-balance-finance",
    saveOpeningBalanceFinance: "/opening-balance-finance/save",
    updateOpeningBalanceFinance: "/opening-balance-finance/update",
    deleteOpeningBalanceFinance: "/opening-balance-finance/delete",
    getOpeningBalanceFinanceById: "/opening-balance-finance/getById",
    searchOpeningBalanceFinance: "/opening-balance-finance/search",
    getAllOpeningBalanceFinanceList: "/opening-balance-finance/getAll",
    uploadBulkOpeningBalanceFinance: "/opening-balance-finance/uploadBulk",
  },

  openingBalanceKarmaController: {
    getAllOpeningBalanceKarma: "/opening-balance-karma",
    searchOpeningBalanceKarma: "/opening-balance-karma/search",
    saveOpeningBalanceKarma: "/opening-balance-karma/save",
    updateOpeningBalanceKarma: "/opening-balance-karma/update",
    deleteOpeningBalanceKarma: "/opening-balance-karma/delete",
    getOpeningBalanceKarmaById: "/opening-balance-karma/getById",
    getAllOpeningBalanceKarmaList: "/opening-balance-karma/getAll",
    uploadBulkOpeningBalanceKarma: "/opening-balance-karma/uploadBulk",
  },

  accountTypeMasterController: {
    getAllAccountTypeMaster: "/accountType",
    saveAccountTypeMaster: "/accountType/save",
    updateAccountTypeMaster: "/accountType/update",
    deleteAccountTypeMaster: "/accountType/delete",
    getAccountTypeMasterById: "/accountType/getById",
    getAllAccountTypeMasterBySearch: "/accountType/search",
    findAllAccountTypeMaster: "/accountType/getAll",
    bulkSaveAccountTypeMaster: "/accountType/uploadBulk",
  },



  scenarioMasterController: {
    getAllScenarioMaster: "/scenario",
    getScenarioMasterById: "/scenario/getById",
    saveScenarioMaster: "/scenario/save",
    updateScenarioMaster: "/scenario/update",
    deleteScenarioMaster: "/scenario/delete",
    searchScenarioMaster: "/scenario/search",
    findAllScenarioMaster: "/scenario/getAll",
    bulkUploadScenarioMaster: "/scenario/uploadBulk",
    getAllReligions: "/scenario/getAllReligions",
  },

  voucherTypekarmaMasterController: {
    getAll: "/voucher-type-karma/getAll",
    getById: "/voucher-type-karma/getById",
    save: "/voucher-type-karma/save",
    update: "/voucher-type-karma/update",
    delete: "/voucher-type-karma/delete",
    search: "/voucher-type-karma/search",
    getAllPaginated: "/voucher-type-karma",
    uploadBulk: "/voucher-type-karma/uploadBulk",
  },
  voucherTypeFinanceMasterController: {
    getAll: "/voucher-type-finance/getAll",
    getById: "/voucher-type-finance/getById",
    save: "/voucher-type-finance/save",
    update: "/voucher-type-finance/update",
    delete: "/voucher-type-finance/delete",
    search: "/voucher-type-finance/search",
    getAllPaginated: "/voucher-type-finance",
    uploadBulk: "/voucher-type-finance/uploadBulk",
  },


  scripturalReferenceMasterController: {
    getAll: "/scripturalReference",
    getById: "/scripturalReference/getById",
    save: "/scripturalReference/save",
    update: "/scripturalReference/update",
    delete: "/scripturalReference/delete",
    search: "/scripturalReference/search",
    findAll: "/scripturalReference/getAll",
    bulkUpload: "/scripturalReference/uploadBulk",
  },
  voucherFinanceController: {
    getAllVoucherFinance: "/voucherFinance",
    getVoucherFinanceById: "/voucherFinance/getById",
    saveVoucherFinance: "/voucherFinance/save",
    updateVoucherFinance: "/voucherFinance/update",
    deleteVoucherFinance: "/voucherFinance/delete",
    searchVoucherFinance: "/voucherFinance/search",
    getSearchVoucherFinance: "/voucherFinance/getSearch",
    findAllVoucherFinance: "/voucherFinance/getAll",
    bulkUploadVoucherFinance: "/voucherFinance/uploadBulk",
    findAllVoucherFinanaceApprovalStatus: "/voucherFinance/approvalStatuses",
    getAllParties: "/voucherFinance/parties",
  },

  voucherKarmaController: {
    getAllVoucherKarma: "/voucherKarma",
    getVoucherKarmaById: "/voucherKarma/getById",
    saveVoucherKarma: "/voucherKarma/save",
    updateVoucherKarma: "/voucherKarma/update",
    deleteVoucherKarma: "/voucherKarma/delete",
    searchVoucherKarma: "/voucherKarma/searchWithDate",
    getSearchVoucherKarma: "/voucherKarma/getSearch",
    findAllVoucherKarma: "/voucherKarma/getAll",
    bulkUploadVoucherKarma: "/voucherKarma/uploadBulk",
    getAllPurposeCodes: "/voucherKarma/purposeCodes",
  },

  voucherParticipantController: {
    getAllVoucherParticipant: "/voucherParticipant",
    getVoucherParticipantById: "/voucherParticipant/getById",
    saveVoucherParticipant: "/voucherParticipant/save",
    updateVoucherParticipant: "/voucherParticipant/update",
    deleteVoucherParticipant: "/voucherParticipant/delete",
    getAllVoucherParticipantBySearch: "/voucherParticipant/search",
    getSearchVoucherParticipant: "/voucherParticipant/getSearch",
    findAllVoucherParticipant: "/voucherParticipant/getAll",
    bulkSaveVoucherParticipant: "/voucherParticipant/uploadBulk",
  },

  inventoryCategoryMasterController: {
    getAllInventoryCategoryMaster: "/inventoryCategory/getAll",
    getInventoryCategoryMasterById: "/inventoryCategory/getById",
    getAllInventoryCategoryMasterWithPagination: "/inventoryCategory",
    saveInventoryCategoryMaster: "/inventoryCategory/save",
    updateInventoryCategoryMaster: "/inventoryCategory/update",
    deleteInventoryCategoryMaster: "/inventoryCategory/delete",
    searchInventoryCategoryMaster: "/inventoryCategory/search",
    bulkUploadInventoryCategoryMaster: "/inventoryCategory/uploadBulk",
  },

  inventoryItemMasterController: {
    getAllInventoryItemMaster: "/inventoryItem/getAll",
    getInventoryItemMasterById: "/inventoryItem/getById",
    getAllInventoryItemMasterWithPagination: "/inventoryItem",
    saveInventoryItemMaster: "/inventoryItem/save",
    updateInventoryItemMaster: "/inventoryItem/update",
    deleteInventoryItemMaster: "/inventoryItem/delete",
    searchInventoryItemMaster: "/inventoryItem/search",
    bulkUploadInventoryItemMaster: "/inventoryItem/uploadBulk",
  },

  dashboardController: {
    getDashboardData: "/dashboard",
    exportTables: "/dashboard/tables",
    exportScriptureReferences: "/dashboard/scripture-references",
    exportFinancialStatements: "/dashboard/financial-statements",
  },
  
  accountLedgerController: {
    getLedger: "/ledger/get",
    exportExcel: "/ledger/export-excel"
  },

  inventoryOpeningBalanceController: {
    getAllInventoryOpeningBalance: "/inventoryOpeningBalance/getAll",
    getInventoryOpeningBalanceById: "/inventoryOpeningBalance/getById",
    getAllInventoryOpeningBalanceWithPagination: "/inventoryOpeningBalance",
    saveInventoryOpeningBalance: "/inventoryOpeningBalance/save",
    updateInventoryOpeningBalance: "/inventoryOpeningBalance/update",
    deleteInventoryOpeningBalance: "/inventoryOpeningBalance/delete",
    searchInventoryOpeningBalance: "/inventoryOpeningBalance/search",
    bulkUploadInventoryOpeningBalance: "/inventoryOpeningBalance/uploadBulk",
  },


  inventoryTransactionsController: {
    getAllInventoryTransactions: "/inventoryTransactions/getAll",
    getInventoryTransactionsById: "/inventoryTransactions/getById",
    getAllInventoryTransactionsWithPagination: "/inventoryTransactions", // {page}/{offset}?orderBy=
    saveInventoryTransactions: "/inventoryTransactions/save",
    updateInventoryTransactions: "/inventoryTransactions/update",
    deleteInventoryTransactions: "/inventoryTransactions/delete",
    searchInventoryTransactions: "/inventoryTransactions/search",
    bulkUploadInventoryTransactions: "/inventoryTransactions/uploadBulk",
  },


  tokenMechanismMasterController: {
    getAll: "/token-mechanism/getAll",
    getById: "/token-mechanism/getById",
    save: "/token-mechanism/save",
    update: "/token-mechanism/update",
    delete: "/token-mechanism/delete",
    search: "/token-mechanism/search",
    getAllWithPagination: "/token-mechanism",
    uploadBulk: "/token-mechanism/uploadBulk",
  },

  aiProcessingLogController: {
    getAll: "/aiProcessingLog/getAll",
    getById: "/aiProcessingLog/getById",
    save: "/aiProcessingLog/save",
    update: "/aiProcessingLog/update",
    delete: "/aiProcessingLog/delete",
    search: "/aiProcessingLog/search",
    getAllWithPagination: "/aiProcessingLog",
    uploadBulk: "/aiProcessingLog/uploadBulk",
  },

  auditLogsController: {
    getAll: "/auditLog/getAll",
    getById: "/auditLog/getById",
    save: "/auditLog/save",
    update: "/auditLog/update",
    delete: "/auditLog/delete",
    search: "/auditLog/search",
    getAllWithPagination: "/auditLog",
    bulkSave: "/auditLog/bulkSave",

  },

  partyCategoryMasterController: {
    getPartyCategoryMasterById: "/partyCategoryMaster/getById",
    updatePartyCategoryMaster: "/partyCategoryMaster/update",
    deletePartyCategoryMaster: "/partyCategoryMaster/delete",
    findAllPartyCategoryMaster: "/partyCategoryMaster/getAll",
    savePartyCategoryMaster: "/partyCategoryMaster/save",
    getAllPartyCategoryMasterBySearch: "/partyCategoryMaster/search",
    getAllPartyCategoryMaster: "/partyCategoryMaster",
    bulkSavePartyCategoryMaster: "/partyCategoryMaster/uploadBulk",
  },



};

export const dataService = {
  valueChainCategoryController: {
    getAllValueChainCategoryWithPagination: "/valuechaincategories/with-pagination",
    updateValueChainCategory: "/valuechaincategories",
    deleteValueChainCategoryById: "/valuechaincategories",
    getValueChainCategoryById: "/valuechaincategories",
    saveValueChainCategory: "/valuechaincategories",
    getAllValueChainCategoryWithSearch: "/valuechaincategories/getAllWithSearch",
    getAllValueChainCategory: '/valuechaincategories/findAll',
    getValueChainCategoryByAgentMasterId: "/valuechaincategories/by-agent-master",
    bulkSaveValueChainCategory: "/valuechaincategories/bulk-create",
  },

  valueChainsController: {
    getValueChainsById: "/valuechains",
    updateValueChain: "/valuechains",
    deleteValueChainById: "/valuechains",
    getAllValueChainsWithPagination: "/valuechains/with-pagination",
    saveValueChain: "/valuechains",
    getAllValueChainsWithSearch: "/valuechains/getAllWithSearch",
    getValueChainCategoryCountName: "/valuechains/getCountAndValueChainCategoryName",
    getAllValueChains: "/valuechains/findAll",
    bulkSaveValueChain: "/valuechains/bulk-create",
  },
  responsibilityCenterController: {
    getResponsibilityCenterById: "/responsibilityCenter",
    updateResponsibilityCenter: "/responsibilityCenter",
    deleteResponsibilityCenterById: "/responsibilityCenter",
    getAllResponsibilityCenters: "/responsibilityCenter/search",
    saveResponsibilityCenter: "/responsibilityCenter",
    getAllResponsibilityCentersWithSearch: "/responsibilityCenter/search",
    bulkSaveResponsibilityCenter: "/responsibilityCenter/bulk-create",
  },
  responsibilityGroupController: {
    getResponsibilityGroupById: "/responsibilityGroup",
    updateResponsibilityGroup: "/responsibilityGroup",
    deleteResponsibilityGroupById: "/responsibilityGroup",
    findAllResponsibilityGroup: "/responsibilityGroup/all",
    saveResponsibilityGroup: "/responsibilityGroup",
    getAllResponsibilityGroupsWithSearch: "/responsibilityGroup/search",
    getAllResponsibilityGroups: "/responsibilityGroup/search",
    bulkSaveResponsibilityGroup: "/responsibilityGroup/bulk-create",
  },
  agentMasterController: {
    getAgentMasterById: "/agentMaster",
    updateAgentMaster: "/agentMaster/update",
    deleteAgentMasterById: "/agentMaster",
    getAllAgentMasterWithPagination: "/agentMaster/with-pagination",
    saveAgentMaster: "/agentMaster/save",
    getAllAgentMasterWithSearch: "/agentMaster/getAllWithSearch",
    getAllAgentMaster: "/agentMaster/findAll",
    bulkSaveAgentMaster: "/agentMaster/bulk-create",
  },
};

export const webUI = {
  webSearchController: {
    getResultByTerms: "/getResultByTerms",
    searchForCompany: "/searchforcompany",
    getDetailSearch: "/getDetailSearch"
  },
};